import type { ReorderCapability } from '../model/capabilities';
import type { BlockedReason } from '../model/operations';
import { LABEL_KEYS, type Message } from './messages';
import type { ReorderViewModel } from './rowTypes';

// Only these reasons reach the handle: capabilities offers no handle for the others. They stay
// in the map to keep it exhaustive.
const BLOCKED_MESSAGES: Record<BlockedReason, Message | null> = {
  SAME_TARGET_IN_FLIGHT: null,
  REORDER_IN_FLIGHT: null,
  MUTATION_IN_FLIGHT: { key: LABEL_KEYS.blockedMutationInFlightTooltip },
  REPLICA_STALE: { key: LABEL_KEYS.blockedStaleTooltip },
  NOT_PERMITTED: null,
};

export function createReorderViewModel(
  { canReorder, blockedReason }: ReorderCapability,
  handleLabel: Message
): ReorderViewModel {
  return {
    canReorder,
    disabledReason: blockedReason ? BLOCKED_MESSAGES[blockedReason] : null,
    handleLabel,
  };
}
